import '../assets/stylesheets/preorder.css'
import amazonIcon from '../assets/icons/amazon.png';
import {Link} from 'react-router-dom';
export default function Preorder (){
    return (
        <section className="releasecontainer">
            <h2 className="pagetitle">Order Your Favorite Releases</h2>
            <section className="releases">
                <section className="release">
                    <img src={require('../assets/images/coverquokka.png')} alt="The Smiling Quokka book" />
                    <Link to='https://www.amazon.com/dp/B0F1MCRYHJ?ref_=pe_93986420_775043100' target="_blank" rel="noopener" className="orderbtn"> <span>Order Now</span> <img src={amazonIcon} alt="buy the talking quokka book by abigail gordon" id="buyicon" /> </Link>
                </section>           
            </section>
            
        </section>
    );

}